import script from "./AddNewEntityButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddNewEntityButton.vue?vue&type=script&setup=true&lang=js"

import "./AddNewEntityButton.vue?vue&type=style&index=0&id=140e939a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-140e939a"]])

export default __exports__